import _ from 'lodash';
import React, { useState } from 'react';

import { Popper, Placements } from '@videoblocks/storywind';

import FolderSelector from '../../app/FolderSelector/FolderSelector';

interface Props {
  disabled?: boolean;
  copySelectedStockItemsToFolder?: ({ string }) => void;
  createAndCopySelectedStockItemsToFolder?: ({ string }) => void;
  selectedItems?: [];
  showSelectItemsModal?: () => void;
}

const CopyToFolderButton = ({
  disabled = false,
  copySelectedStockItemsToFolder = _.noop,
  createAndCopySelectedStockItemsToFolder = _.noop,
  selectedItems = [],
  showSelectItemsModal = _.noop,
}: Props) => {
  const [showFolderSelector, setShowFolderSelector] = useState(false);

  const handleSelectFolder = ({ bin }) => {
    copySelectedStockItemsToFolder(bin);
    setShowFolderSelector(false);
  };

  const handleCreateNewFolder = ({ name }) => {
    createAndCopySelectedStockItemsToFolder(name);
    setShowFolderSelector(false);
  };

  const handleClickButton = () => {
    if (selectedItems.length < 1) {
      showSelectItemsModal();
    } else {
      setShowFolderSelector(!showFolderSelector);
    }
  };

  return (
    <Popper
      hideContent={() => setShowFolderSelector(false)}
      offset={[0, 12]}
      placement={Placements.Bottom}
      showContent={showFolderSelector}
      triggerElement={(referenceElement) => (
        <button
          className="gridFolderContainer-iconButton relative"
          disabled={disabled}
          id="copyItems"
          onClick={() => handleClickButton()}
          ref={referenceElement}
        >
          <img
            alt="Copy to folder icon"
            className="gridFolderContainer-commandIcon"
            src={__ASSETS_COMMON_IMAGES_URL__ + '/member/folders/copy.svg'}
            title="Copy to folder"
          />
        </button>
      )}
    >
      <FolderSelector
        folderClickedCallback={handleSelectFolder}
        createNewClickedCallback={handleCreateNewFolder}
        title="Find or Create Folder"
      />
    </Popper>
  );
};

export default CopyToFolderButton;
